import { useState, useEffect } from 'react';

interface SentimentFilterProps {
    onSentimentChange: (sentiments: string[]) => void;
    onConfidenceChange: (confidence: number) => void;
    defaultSelectedSentiments?: string[];
    defaultConfidence?: number;
}

export default function SentimentFilter({
    onSentimentChange,
    onConfidenceChange,
    defaultSelectedSentiments = [],
    defaultConfidence = 70
}: SentimentFilterProps) {
    const [selected, setSelected] = useState<string[]>(defaultSelectedSentiments);
    const [confidence, setConfidence] = useState<number>(defaultConfidence);

    useEffect(() => {
        setSelected(defaultSelectedSentiments);
    }, [defaultSelectedSentiments]);

    useEffect(() => {
        setConfidence(defaultConfidence);
    }, [defaultConfidence]);

    const handleToggle = (sentiment: string) => {
        const newSelected = selected.includes(sentiment)
            ? selected.filter(s => s !== sentiment)
            : [...selected, sentiment];
        setSelected(newSelected);
        onSentimentChange(newSelected);
    };

    const handleConfidenceChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = parseInt(e.target.value);
        setConfidence(value);
        onConfidenceChange(value);
    };

    const sentimentConfig = {
        positive: { label: 'Positiv', color: '#22c55e' },
        neutral: { label: 'Neutral', color: '#6b7280' },
        negative: { label: 'Negativ', color: '#ef4444' }
    };

    return (
        <div className="sentiment-filter">
            <div className="sentiment-checkboxes">
                {Object.entries(sentimentConfig).map(([key, config]) => (
                    <label key={key} className="sentiment-checkbox">
                        <input
                            type="checkbox"
                            checked={selected.includes(key)}
                            onChange={() => handleToggle(key)}
                        />
                        <span style={{ color: config.color }}>{config.label}</span>
                    </label>
                ))}
                <div className="confidence-slider">
                    <label>
                        Min. Confidence: {confidence}%
                        <input
                            type="range"
                            min="0"
                            max="100"
                            value={confidence}
                            onChange={handleConfidenceChange}
                        />
                    </label>
                </div>
            </div>
        </div>
    );
}